import React, { useState, useEffect } from 'react'
import { apiHandler } from '../../api/apihandler';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { Link, useLocation, useNavigate, Outlet } from 'react-router-dom'
import { NOTIFICATION_COUNT, GET_CONNECTED_USERS, GENERAL_SETTINGS, AI_CHAT_START } from "../../api/constants";
import { io } from "socket.io-client";
import Header from '../../components/partials/dashboard/HeaderStyle/header'
import RightSidebar from '../../components/partials/dashboard/SidebarStyle/rightsidebar'
import Sidebar from '../../components/partials/dashboard/SidebarStyle/sidebar'
import Footer from '../../components/partials/dashboard/FooterStyle/footer'

// Redux Selector / Action
import { useDispatch, useSelector } from 'react-redux';
import { setIsOptimizing, setGeneralSettings as setGeneralSettingsRedux } from '../../store/setting/actions'
//default 
// import DefaultRouter from '../../router/default-router'

// share-offcanvas
// import ShareOffcanvas from '../../components/share-offcanvas'

//settingoffCanvas
import SettingOffCanvas from '../../components/setting/SettingOffCanvas'
import DefaultHeader from '../../components/partials/dashboard/HeaderStyle/defaultHeader';

const Default = () => {
    const dispatch = useDispatch()
    let location = useLocation();
    const socket = io(process.env.REACT_APP_API_BASE_URL);
    const navigate = useNavigate();
    let profileData = (useSelector((state) => state.setting.setting.user_data))
    profileData = profileData ? JSON.parse(profileData) : "";

    const [notificationCount, setNotificationCount] = useState(0);
    const [onlineUserList, setOnlineUserList] = useState([]);
    const [generalSettings, setGeneralSettings] = useState('');

    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
    const [showAIChatModal, setShowAIChatModal] = useState(false);

    useEffect(() => {
        getGeneralSettings()
        if (localStorage.getItem("uzoneAuthToken")) {
            getNotificationCount()
            getOnlineUserListApi()
            socketLogedInSetup()
            if ((profileData?.user_setting?.is_influencer != 1 || profileData?.user_setting?.is_dance_corner != 1 ||
                profileData?.user_type != 2 || profileData?.user_type != 4
            ) && profileData?.user_setting?.user_mood > 3
            ) {
                getAIChatStartApi()
            }
        } else {
            navigate('/')
        }

        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
        };
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    function socketLogedInSetup() {
        const userId = profileData?.id;
        // Listen for events from the server
        socket.on('connect', () => {
            // console.log('Connected to the server');
            socket.emit("login", userId);
        });

        // Listen for events from the server
        socket.on('disconnect', () => {
            socket.emit("logedout", userId);
            // console.log('DisConnected from the server');
        });
        socket.on('error', () => {
            console.log('DisConnected from the server');
        });

        socket.on('notificationUpdate', (message) => {
            //console.log('logedin users list:', message);
            setNotificationCount(message)
            // console.log('notification Count socket:', message);
        });
        socket.on('logedinusers', (message) => {
            // console.log('logedin users list:', message);
            getOnlineUserListApi()
        });
        socket.on('userlogedout', (message) => {
            // console.log('logedin users list:', message);
            getOnlineUserListApi()
        });
        socket.on('mediaOptimized', (message) => {
            console.log('optimized:', message);
            dispatch(setIsOptimizing(true));
        });
    }

    async function getGeneralSettings() {
        try {
            const res = await apiHandler(GENERAL_SETTINGS, "POST", {
            })
            if (res.data?.response?.status === 200) {
                setGeneralSettings(res?.data?.data?.generalSettings)
                dispatch(setGeneralSettingsRedux(JSON.stringify(res?.data?.data?.generalSettings)));
            }
        } catch (error) {
            console.error(error);
        }
    }

    async function getNotificationCount() {
        try {
            const res = await apiHandler(NOTIFICATION_COUNT, "POST")
            if (res.data?.response?.status === 200) {
                setNotificationCount(res?.data?.data?.count)
                //console.log('notification Count:', res?.data?.data?.count);
            } else {
                //addToast(res?.response?.data?.data?.message, { appearance: 'error' });
            }
        } catch (error) {
            console.error(error);
        } finally {
        }
    }

    async function getOnlineUserListApi() {
        try {
            const res = await apiHandler(GET_CONNECTED_USERS, 'POST', {
                is_online: '1'
            });
            if (res.data?.response?.status === 200) {
                setOnlineUserList(res?.data?.data?.users?.data)
            } else {
                setOnlineUserList([])
            }
        } catch (error) {
            console.error(error);
        } finally {
        }
    }

    async function getAIChatStartApi() {
        try {
            const res = await apiHandler(AI_CHAT_START, 'POST');
            if (res.data?.response?.status === 200) {
                setShowAIChatModal(true);
            } else {
            }
        } catch (error) {
            console.error(error);
        } finally {
        }
    }

    return (
        <>
            {
                localStorage.getItem("uzoneAuthToken") ?
                    location.pathname === '/' || location.pathname === '/privacy-policy' || location.pathname === '/about-us'
                        || location.pathname === '/contact-us' || location.pathname === '/terms-of-use' ? null :
                        <Sidebar /> : null
            }
            <Header notificationCount={notificationCount} />
            {/* {
                localStorage.getItem("uzoneAuthToken") ?
                    <Header notificationCount={notificationCount} /> :
                    <DefaultHeader />
            } */}
            <div className="main-content">
                {/* <div id="content-page" className="content-page"> */}
                {/* <DefaultRouter/> */}
                <Outlet />
                {/* </div> */}
            </div>
            {
                localStorage.getItem("uzoneAuthToken") ?
                    location.pathname === '/' || location.pathname === '/privacy-policy' || location.pathname === '/about-us'
                        || location.pathname === '/contact-us' || location.pathname === '/terms-of-use' ? null :
                        profileData?.user_type === 4 ? null :
                            <RightSidebar onlineUserList={onlineUserList} /> : null
            }
            {
                localStorage.getItem("uzoneAuthToken") ?
                    isMobile ?
                        <div style={{ background: "white", width: "100%", justifySelf: "center" }}>
                            <Footer />
                        </div> :
                        location.pathname === '/' ?
                            <div style={{ background: "white", width: "100%", justifySelf: "center" }}>
                                <Footer />
                            </div> :
                            <div style={{ background: "white", width: "72%", justifySelf: "center" }}>
                                <Footer />
                            </div>
                    :
                    <div style={{ background: "white", width: "100%", justifySelf: "center" }}>
                        <Footer />
                    </div>
            }

            <Modal
                show={showAIChatModal}
                onHide={() => setShowAIChatModal(false)}
                centered
                backdrop="static"
                keyboard={false}
            >
                <Modal.Body className="text-center p-4" style={{ borderRadius: 16 }}>
                    <img
                        src="https://cdn-icons-png.flaticon.com/512/4712/4712035.png"
                        alt="AI Friend"
                        style={{ width: 80, marginBottom: 16 }}
                    />
                    <h4 style={{ fontWeight: 700, color: "#1976d2" }}>You have one friend waiting to talk to you.</h4>
                    <p style={{ color: "#555", marginTop: 12, marginBottom: 24 }}>
                        Would you like to start a conversation with your AI Counsellor now?
                    </p>
                    <div className="d-flex justify-content-center gap-3">
                        <Button
                            variant="primary"
                            style={{ minWidth: 100, fontWeight: 600 }}
                            onClick={() => {
                                setShowAIChatModal(false);
                                window.open(`/chat/index?type=user&slug=${"ai-chat"}`, '_blank');
                            }}
                        >
                            Yes
                        </Button>
                        <Button
                            variant="outline-secondary"
                            style={{ minWidth: 100, fontWeight: 600 }}
                            onClick={() => setShowAIChatModal(false)}
                        >
                            Not Now
                        </Button>
                    </div>
                </Modal.Body>
            </Modal>
            {/* <SettingOffCanvas /> */}
        </>
    )
}

export default Default
